export const getPdfJsWorkerSrc = (pdfjsLib) => {
  const version = pdfjsLib?.version || "5.6.205";
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/legacy/build/pdf.worker.min.mjs`;
};

export const configurePdfJsWorker = (pdfjsLib) => {
  if (!pdfjsLib?.GlobalWorkerOptions) return;
  const workerSrc = getPdfJsWorkerSrc(pdfjsLib);
  if (pdfjsLib.GlobalWorkerOptions.workerSrc !== workerSrc) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
  }
};
